import { useEffect } from 'react';
import Header from '../../../components/base/Header';
import Footer from '../../../components/base/Footer';
import { Link } from 'react-router-dom';

export default function BirthFlowerGuideBlog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-rose-50 to-orange-50">
      <Header />

      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-r from-teal-500 via-cyan-500 to-emerald-500">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-calendar-check-line text-5xl text-white"></i>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              今日の誕生花を探す機能について
            </h1>
            <p className="text-xl text-white/90 mb-6">
              ──あなたの特別な日に咲く花を見つけよう──
            </p>
            <div className="flex items-center justify-center gap-4 text-white/90">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                2025年11月4日
              </span>
              <span className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                ティランちゃん
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/7eed25f69c286b4cab5e9f9ba2948ad4.jpeg"
                alt="ティランちゃん"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                やっほー！モモちゃん畑のティランちゃんだよ🌿<br />
                今日は、このサイトの便利な機能<br />
                「今日の誕生花を探す」について紹介するね！
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                誕生日や記念日、大切な日に咲く花を知りたいと思ったことない？<br />
                この機能を使えば、365日すべての日に対応した誕生花が見つかるんだ✨
              </p>
            </div>

            {/* Section 1 */}
            <div className="mb-12 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌿</span>
                「今日の誕生花を探す」ってどんな機能？
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  この機能は、カレンダーから日付を選ぶだけで、<br />
                  その日の誕生花と花言葉を教えてくれる便利なツールなんだ。
                </p>
                <div className="bg-white rounded-2xl p-6 my-6 border-l-4 border-teal-400">
                  <p className="text-teal-700 font-medium text-lg">
                    「今日は何の花かな？」<br />
                    「友達の誕生日の花を知りたい！」<br />
                    「記念日にぴったりの花言葉を見つけたい」
                  </p>
                </div>
                <p>
                  そんなときに、ぱぱっと調べられるのがこの機能の魅力！
                </p>
                <p className="font-medium text-teal-800">
                  自由気ままなボクでも、<br />
                  簡単に使えるシンプルな設計になってるよ🌱
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-green-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">📅</span>
                使い方はとってもカンタン！3ステップ
              </h2>
              <div className="space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <span className="text-2xl font-bold text-green-700">①</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-green-800 mb-2">
                        カレンダーから日付を選ぶ
                      </h3>
                      <p className="text-gray-700">
                        画面に表示されるカレンダーから、<br />
                        知りたい日付をクリックするだけ。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <span className="text-2xl font-bold text-green-700">②</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-green-800 mb-2">
                        誕生花と花言葉が表示される
                      </h3>
                      <p className="text-gray-700">
                        選んだ日の誕生花の名前、花言葉、<br />
                        そして美しい花の写真が表示されるよ。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <span className="text-2xl font-bold text-green-700">③</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-green-800 mb-2">
                        モモちゃんからのメッセージも届く
                      </h3>
                      <p className="text-gray-700">
                        その花にまつわる優しいメッセージが、<br />
                        あなたの心にそっと寄り添ってくれるんだ。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-12 bg-gradient-to-br from-cyan-50 to-sky-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-cyan-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">💡</span>
                こんなときに使ってみて！
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="mb-6">
                  誕生花を調べる機能は、いろんなシーンで活躍するよ。<br />
                  ボクのおすすめの使い方を紹介するね！
                </p>

                <div className="space-y-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">🎂</span>
                      誕生日プレゼントの参考に
                    </h3>
                    <p>
                      友達や家族の誕生日に、<br />
                      その日の誕生花を贈るのって素敵じゃない？<br />
                      花言葉を添えたメッセージカードも喜ばれるよ。
                    </p>
                  </div>

                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">💍</span>
                      記念日を花で彩る
                    </h3>
                    <p>
                      結婚記念日、出会った日、大切な記念日……<br />
                      その日の誕生花を知ることで、<br />
                      特別な日がもっと思い出深くなるんだ。
                    </p>
                  </div>

                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">🌸</span>
                      自分の誕生花を知る楽しみ
                    </h3>
                    <p>
                      自分が生まれた日の花を知るって、<br />
                      なんだかワクワクしない？<br />
                      花言葉が自分にぴったりだったりすると嬉しくなるよね。
                    </p>
                  </div>

                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">📖</span>
                      日々の花の勉強に
                    </h3>
                    <p>
                      毎日違う花を知ることで、<br />
                      花の知識がどんどん増えていくよ。<br />
                      365日、毎日新しい発見があるんだ！
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 4 */}
            <div className="mb-12 bg-gradient-to-br from-emerald-50 to-green-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-emerald-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌱</span>
                ティランちゃんの豆知識コーナー
              </h2>
              <h3 className="text-xl font-bold text-emerald-700 mb-6">
                ──誕生花って、どうやって決まるの？
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  実は誕生花って、国や地域によって違うんだ。<br />
                  日本では、その季節に咲く花や、<br />
                  歴史的な背景、花言葉の意味などから選ばれているよ。
                </p>
                <div className="bg-white rounded-2xl p-6 my-6">
                  <p className="text-gray-700 mb-4">
                    例えば……
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start">
                      <span className="text-emerald-500 mr-3 mt-1">✿</span>
                      <p><span className="font-bold text-emerald-700">春</span>には桜やチューリップ</p>
                    </div>
                    <div className="flex items-start">
                      <span className="text-emerald-500 mr-3 mt-1">✿</span>
                      <p><span className="font-bold text-emerald-700">夏</span>にはひまわりやアサガオ</p>
                    </div>
                    <div className="flex items-start">
                      <span className="text-emerald-500 mr-3 mt-1">✿</span>
                      <p><span className="font-bold text-emerald-700">秋</span>にはコスモスやキク</p>
                    </div>
                    <div className="flex items-start">
                      <span className="text-emerald-500 mr-3 mt-1">✿</span>
                      <p><span className="font-bold text-emerald-700">冬</span>にはシクラメンやポインセチア</p>
                    </div>
                  </div>
                </div>
                <p className="font-medium text-emerald-800">
                  季節の移り変わりと一緒に、<br />
                  花も変わっていくのが面白いよね🌿
                </p>
              </div>
            </div>

            {/* Section 5 */}
            <div className="mb-12 bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-rose-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🎁</span>
                花言葉を添えて、気持ちを伝えよう
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  誕生花を調べたら、<br />
                  ぜひその花言葉にも注目してみて。
                </p>
                <p>
                  花言葉は、言葉にしにくい気持ちを<br />
                  そっと伝えてくれる素敵なツールなんだ。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-rose-200">
                  <p className="text-xl font-bold text-rose-800 mb-4">
                    「ありがとう」<br />
                    「大好き」<br />
                    「いつも応援してるよ」
                  </p>
                  <p className="text-lg text-gray-700">
                    そんな気持ちを、花言葉に乗せて届けてみてね💐
                  </p>
                </div>
              </div>
            </div>

            {/* Section 6 */}
            <div className="mb-12 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌈</span>
                ティランちゃんからのメッセージ
              </h2>
              <h3 className="text-xl font-bold text-teal-700 mb-6">
                ──毎日が特別な日になるように
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ボクはエアープランツだから、<br />
                  土がなくても自由に生きられるんだ。
                </p>
                <p>
                  でも、どんな花も植物も、<br />
                  それぞれの場所で、それぞれのペースで咲いている。
                </p>
                <p>
                  誕生花を調べることは、<br />
                  その日に咲く花の個性を知ること。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-teal-200">
                  <p className="text-2xl font-bold text-teal-800 mb-4">
                    あなたの大切な日にも、<br />
                    きっと素敵な花が咲いているよ。
                  </p>
                  <p className="text-lg text-gray-700">
                    ぜひ、探してみてね🌿✨
                  </p>
                </div>
              </div>
            </div>

            {/* CTA to Today Flower */}
            <div className="mb-12 text-center">
              <Link
                to="/today-flower"
                className="inline-flex items-center bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-calendar-check-line mr-2"></i>
                今日の誕生花を探す
              </Link>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-12">
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #誕生花
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #花言葉
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #使い方
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #ティランちゃん
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #記念日
              </span>
            </div>

            {/* Back Button */}
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                エッセイ一覧に戻る
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-rose-800 mb-8 text-center">
              他のブログ記事も読む
            </h2>
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center text-rose-600 hover:text-rose-700 font-medium transition-colors"
              >
                すべての記事を見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
